import ComponentCard from "../../components/common/ComponentCard";
import PostListComponent from "../../components/post/PostListComponent";
import React from "react";
import OrderListComponent from "../../components/order/OrderListComponent";

const PostList = () => {
    return (
        <>
            <div className="space-y-6">
                <ComponentCard title="">
                    <OrderListComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default PostList;